import Alert from './Alert'

const AlertContainer = () => {
    return (
        <div className='alert-container'>
            <Alert/>    
        </div>
    )
}

export default AlertContainer;